// TODO: this is copied from plan. we should just factor it out
import styled from '@emotion/styled';

export const Icon = styled.span`
    align-items: center;
    display: inline-flex;
    justify-content: center;
    height: 1rem;
    width: 1rem;
    cursor: pointer;
`

export const GrayIcon = styled(Icon)`
    color: #999999;
`;